import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { seedApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Sun, Loader2, Shield } from 'lucide-react';
import { toast } from 'sonner';

const SetupPage = () => {
  const [seeding, setSeeding] = useState(false);
  const [created, setCreated] = useState(false);
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const navigate = useNavigate();

  const handleSeedAdmin = async () => {
    setSeeding(true);
    try {
      const response = await seedApi.createSuperAdmin();
      if (response.data.password) {
        setCredentials({
          email: response.data.email,
          password: response.data.password
        });
        setCreated(true);
        toast.success('Super Admin criado com sucesso!');
      } else {
        toast.info('Super Admin já existe');
        navigate('/login');
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Erro ao criar Super Admin';
      toast.error(message);
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          background: 'linear-gradient(180deg, #1e293b 0%, #334155 50%, #475569 100%)',
        }}
      />

      <div className="w-full max-w-md animate-fade-in relative z-10">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-slate-600 to-slate-800 rounded-2xl mb-4 shadow-2xl">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white">Setup Inicial</h1>
          <p className="text-slate-300 mt-1">Configuração do Sistema</p>
        </div>

        <Card className="border-slate-600 shadow-xl bg-slate-800/90 backdrop-blur-sm">
          <CardHeader className="space-y-1">
            <CardTitle className="text-xl text-white">
              {created ? 'Credenciais Criadas' : 'Criar Super Admin'}
            </CardTitle>
            <CardDescription className="text-slate-400">
              {created 
                ? 'Guarde estas credenciais em local seguro' 
                : 'Execute apenas uma vez para configurar o sistema'}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {created ? (
              <div className="space-y-4">
                <div className="p-4 bg-slate-700 rounded-lg">
                  <p className="text-sm text-slate-400 mb-1">Email:</p>
                  <p className="text-white font-mono">{credentials.email}</p>
                </div>
                <div className="p-4 bg-slate-700 rounded-lg">
                  <p className="text-sm text-slate-400 mb-1">Senha:</p>
                  <p className="text-white font-mono">{credentials.password}</p>
                </div>
                <p className="text-xs text-amber-400 text-center">
                  ⚠️ Anote estas credenciais! Não serão mostradas novamente.
                </p>
                <Button
                  className="w-full bg-slate-600 hover:bg-slate-500"
                  onClick={() => navigate('/login')}
                >
                  Ir para Login
                </Button>
              </div>
            ) : (
              <Button
                className="w-full bg-slate-600 hover:bg-slate-500"
                onClick={handleSeedAdmin}
                disabled={seeding}
              >
                {seeding ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Criando...
                  </>
                ) : (
                  'Criar Super Admin'
                )}
              </Button>
            )}
          </CardContent>
        </Card>

        <p className="text-center text-xs text-slate-500 mt-6">
          Acesso restrito - Área de configuração
        </p>
      </div>
    </div>
  );
};

export default SetupPage;
